interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  noindex?: boolean;
}

/**
 * ページ固有のSEOタグ。React 19 のネイティブメタデータ対応により、ここで描画した
 * <title>/<meta>/<link> は <head> に巻き上げられ、プリレンダHTMLにもそのまま入る
 * （＝サーバーが最初に返すHTMLに各ページ固有の title/canonical が載る）。
 * クライアントでは React が重複を自動でまとめるため、二重にはならない。
 */
export default function SEOHead({
  title,
  description,
  keywords,
  canonical,
  ogType = 'website',
  noindex = false,
}: SEOHeadProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow'} />
    </>
  );
}
